module.exports = __webpack_public_path__ + "static/media/_MIC2336.image.47cb4ff2.png";